import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { MatchDetailsScoreline } from './MatchDetailsScoreline';
import { MatchDetailsTeams } from './MatchDetailsTeams';
import { Member } from 'functions/src/types/firestore/Game/Tournament/Guestlist';
import { CompetitorOutcomeProps } from '../../CompetitorOutcome';
import { Competitor } from '../MatchCompetitor';
import { useMatch } from '../MatchProvider';
import { MatchAggregated } from 'functions/src/types/firestore/Game/Tournament/Bracket';
import { SxProps } from '@mui/material';
import { useDateFormatter } from 'src/hooks/useDateFormatter';
import { useTheme } from '@mui/material/styles';
import { Prize } from 'functions/src/types/firestore/Game/Competition';
import { MatchLiveBadge } from '../MatchLiveBadge';
import { generateRowData } from 'src/util/bracket/generateRowData';

export const DATE_FORMAT: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
};

export type MatchCompetitor = Competitor &
  Pick<CompetitorOutcomeProps, 'outcome' | 'score'>;

export type CompetitorWithMembers = MatchCompetitor & {
  members: Member[];
};

export type MatchDetailsProps = Omit<MatchAggregated<Date>, 'status'> & {
  reward?: Prize;
  rewardSecured?: Prize;
  sx?: SxProps;
};

export function MatchDetails(props: MatchDetailsProps) {
  const { reward, rewardSecured } = props;
  const { outcome, startTime, team1, team2 } = useMatch();
  const theme = useTheme();
  const format = useDateFormatter({ dateFormat: DATE_FORMAT, separator: ', ' });
  const dateFormatted = startTime ? format(startTime) : undefined;
  const rowsData = generateRowData(team1, team2);

  return (
    <MatchLiveBadge>
      <Stack direction="column" height="197px">
        <MatchDetailsScoreline />
        {!!rowsData.length && (
          <MatchDetailsTeams
            rowsData={rowsData}
            sx={{
              borderRadius: reward || rewardSecured ? 'none' : '0 0 10px 10px',
            }}
          />
        )}
        <Stack direction="column" alignItems="center" width="100%">
          {(reward || rewardSecured) && (
            <Typography
              variant="caption"
              color="secondary"
              sx={{ textTransform: 'uppercase', pt: 1 }}
            >
              <>
                {rewardSecured &&
                  `${rewardSecured.amount} ${rewardSecured.currency} Guaranteed. `}
                {reward && (
                  <>
                    <span
                      style={{
                        color: theme.palette.text.secondary,
                      }}
                    >
                      {`Play${!!outcome ? 'ed' : 'ing'} for `}
                    </span>
                    {reward.amount} {reward.currency}
                  </>
                )}
              </>
            </Typography>
          )}
          <Typography variant="caption" color="text.secondary">
            {dateFormatted}
          </Typography>
        </Stack>
      </Stack>
    </MatchLiveBadge>
  );
}
